import * as React from 'react';

import { Box } from '@coursera/coursera-ui';

import type { TabProps } from 'bundles/enterprise-legacy-learner-home/components/InformationCard/TabListCardLayout';
import { Tab } from 'bundles/enterprise-legacy-learner-home/components/InformationCard/TabListCardLayout';
import styles from 'bundles/enterprise-legacy-learner-home/components/InformationCard/styles';
import { TabCaption } from 'bundles/enterprise-legacy-learner-home/components/InformationCard/typography';

type TabWithCaptionProps = TabProps & {};

const TabWithCaption: React.FC<TabWithCaptionProps> = (props) => {
  const { children, label, ...rest } = props;

  return (
    <Tab label={label} {...rest}>
      <TabCaption>{label}</TabCaption>

      <Box flexDirection="row" rootClassName={styles.tabContentColumns}>
        {children}
      </Box>
    </Tab>
  );
};

export default TabWithCaption;
